import { Badge, Dropdown } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";

const TypeImage = ({ type }) => {
  const imageUrl = getJeepRallyMediaUrl(type?.image);

  if (!imageUrl) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          width: "56px",
          height: "40px",
          borderRadius: "6px",
          border: "1px solid #dee2e6",
          fontSize: "10px",
        }}
      >
        No image
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={type?.name || "Type"}
      style={{
        width: "56px",
        height: "40px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #dee2e6",
      }}
    />
  );
};

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString();
};

const TypesTable = ({
  types,
  onView,
  onEdit,
  onToggleStatus,
  isToggling,
  togglingId,
  canManage,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Name</th>
            <th>Key</th>
            <th>Description</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {types.map((type, index) => {
            const typeId = type._id || type.id;
            const isActive = type.status === "active";
            const rowToggling = isToggling && togglingId === typeId;

            return (
              <tr key={typeId || `${type.key}-${index}`}>
                <td>{index + 1}</td>
                <td>
                  <TypeImage type={type} />
                </td>
                <td>{type.name || "-"}</td>
                <td>
                  <Badge bg="secondary">{type.key || "-"}</Badge>
                </td>
                <td>{type.description || "-"}</td>
                <td>
                  <Badge bg={isActive ? "success" : "secondary"}>
                    {type.status || "-"}
                  </Badge>
                </td>
                <td>{formatDate(type.created_at)}</td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(type)}
                        disabled={!typeId}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onEdit(type)}
                        disabled={!typeId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onToggleStatus(type)}
                        disabled={!typeId || isToggling || !canManage}
                      >
                        {rowToggling
                          ? "Updating..."
                          : isActive
                            ? "Deactivate"
                            : "Activate"}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TypesTable;
